<template>
  <div class="container">
    <div class="mb-3">
      <h2 class="text-center">{{ detailRole?.name }} Role Access</h2>
      <div class="row">
        <div v-for="item in listAccess" :key="item.id" class="col-md-12 mb-3">
          <div class="action-module mb-2 font-bold">{{ item.name }}</div>
          <div class="row border-1" v-if="item.action.length > 0">
            <div
              v-for="itemAction in item.action"
              :key="itemAction.id"
              class="col-md-2"
            >
              <div class="d-flex">
                <input
                  class="form-check-input"
                  type="checkbox"
                  :value="itemAction.is_granted"
                  :checked="itemAction.is_granted"
                  :id="`checkbox` + itemAction.id"
                  @click="
                    handleCheckedAction(
                      itemAction.id,
                      itemAction.name,
                      $event.target.checked
                    )
                  "
                />
                <div class="action-name ms-2">{{ itemAction.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <button
        class="btn btn-lg btn-primary"
        type="button"
        aria-expanded="false"
        @click="savePermission"
      >
        Save Permission
      </button>
    </div>
  </div>
</template>
<style scoped>
.action-module {
  font-weight: 700;
}
</style>

<script>
import { toast } from "vue-sonner";
import { useAccessPermissionStore } from "@/stores/access-permission";
import { useRoleStore } from "@/stores/master/role";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";

export default {
  components: {},
  setup() {
    const roleStore = useRoleStore();
    const nodes = ref({});
    const modalShow = ref(false);
    const router = useRouter();
    const detailRole = ref({});
    const accessPermissionStore = useAccessPermissionStore();
    const listAccess = ref();
    const grantedActions = [];

    const loadAccessRole = async () => {
      try {
        const response = await accessPermissionStore.dispatchGetAll(
          router.currentRoute.value.params.id
        );
        listAccess.value = await accessPermissionStore.access;

        listAccess.value.forEach((item) => {
          item.action.forEach((action) => {
            if (action.is_granted) {
              grantedActions.push({
                id: action.id,
                name: action.name,
              });
            }
          });
        });
      } catch (error) {
        console.error("Failed to load nodes:", error);
      }
    };

    const loadDetailRole = async () => {
      const { success, message } = await roleStore.dispatchDetail(
        router.currentRoute.value.params.id
      );
      if (success) {
        detailRole.value = await roleStore.role.data;
      }
    };

    onMounted(() => {
      loadAccessRole();
      loadDetailRole();
    });

    const handleCheckedAction = async (id, name, current) => {
      const index = grantedActions.findIndex((action) => action.id === id);

      if (current) {
        if (index === -1) {
          grantedActions.push({ id, name });
        }
      } else {
        if (index !== -1) {
          grantedActions.splice(index, 1);
        }
      }
    };

    const savePermission = async () => {
      const payload = {};
      payload.role_id = Number(router.currentRoute.value.params.id);
      payload.permission_id = grantedActions;

      const { success, message } = await accessPermissionStore.dispatchSetRole(
        payload
      );

      if (success) {
        toast.success("Access Permission Saved");
      }
    };

    return {
      detailRole,
      nodes,
      modalShow,
      handleCheckedAction,
      listAccess,
      savePermission,
    };
  },
};
</script>
